import { useState, ReactNode } from 'react';
import { VStack, HStack, IconButton, Text } from '@cad-arc';

export function ExpandableContent({
    title,
    children,
    isExpandedByDefault,
}: {
    title: string | ReactNode;
    children: ReactNode;
    isExpandedByDefault?: boolean;
}) {
    const [isExpanded, setIsExpanded] = useState(isExpandedByDefault);

    return (
        <VStack w="100%" alignItems="flex-start">
            <HStack alignItems="center">
                {typeof title === 'string' ? (
                    <Text color="info" fontWeight="bold">
                        {title}
                    </Text>
                ) : (
                    title
                )}
                <IconButton
                    size="sm"
                    variant="ghost"
                    icon="Open"
                    onClick={() => setIsExpanded((previous) => !previous)}
                    style={{
                        ...(isExpanded ? { transform: 'rotate(180deg)' } : {}),
                        transition: '0s',
                    }}
                />
            </HStack>
            {isExpanded && children}
        </VStack>
    );
}
